export function defaultStepState() {
  return {
    activeStep: 0,
    stepDetails: [
      { isComplete: false, label: 'Angebot', component: 'Service' },
      { isComplete: false, label: 'Fahrzeug', component: 'Vehicle' },
      { isComplete: false, label: 'Stützpunkt', component: 'Station' },
      { isComplete: false, label: 'Termin', component: 'Appointment' },
      { isComplete: false, label: 'Buchen', component: 'Overview' },
    ],
  }
}

export default {
  state: () => defaultStepState(),
  mutations: {
    resetStepState(state) {
      Object.assign(state, defaultStepState())
    },
    setActiveStep(state, payload) {
      state.activeStep = payload
    },
    setStepDetailsComplete(state, { step, isComplete }) {
      const newStepDetails = [...state.stepDetails]
      newStepDetails[step - 1].isComplete = isComplete
      state.stepDetails = newStepDetails
    },
    setAllPreviousStepDetailsComplete(state, step) {
      const newStepDetails = [...state.stepDetails]
      newStepDetails.forEach((stepDetail, index) => {
        if (index < step - 1) stepDetail.isComplete = true
      })
      state.stepDetails = newStepDetails
    },
  },
  getters: {
    activeStep(state) {
      return state.activeStep
    },
    stepDetails(state) {
      return state.stepDetails
    },
  },
}
